var map = {
	"./de.json": [
		95894,
		5894
	],
	"./en.json": [
		44174,
		4174
	],
	"./es.json": [
		46725,
		6725
	],
	"./fr.json": [
		94605,
		4605
	],
	"./it.json": [
		83672,
		3672
	],
	"./pt.json": [
		37741,
		7741
	],
	"./ro.json": [
		22354,
		2354
	],
	"./ru.json": [
		74600,
		4600
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72096;
module.exports = webpackAsyncContext;